/**
 * Balance de vérification — cumulative (au) ou par période (ouverture · mouvements · fin).
 */
import { money } from "../_shared";
import { Card, Num, TH, THead, Table } from "./_bits";

export default function TrialBalanceReport({ data }) {
  const period = !!data.date_from;
  const t = data.totals;
  const ok = Math.abs(data.total_debit - data.total_credit) < 0.01;
  return (
    <Card title={period ? `Balance de vérification — du ${data.date_from} au ${data.as_of}` : `Balance de vérification au ${data.as_of}`} testId="report-trial-balance"
      right={<span className={ok ? "text-emerald-700" : "text-rose-700"} data-testid="tb-status">{ok ? "Balance équilibrée ✓" : "Attention : débits ≠ crédits"}</span>}>
      <div className="overflow-x-auto">
        <Table>
          <THead>
            <TH className="w-16">N°</TH><TH>Compte</TH>
            {period && <><TH right>Ouv. débit</TH><TH right>Ouv. crédit</TH><TH right>Débits</TH><TH right>Crédits</TH></>}
            <TH right className="w-32">{period ? "Solde débit" : "Débit"}</TH><TH right className="w-32">{period ? "Solde crédit" : "Crédit"}</TH>
          </THead>
          <tbody className="divide-y">
            {data.rows.map((r) => (
              <tr key={r.account_id} className="hover:bg-emerald-50/40" data-testid={`tb-row-${r.number}`}>
                <td className="px-3 py-1.5 font-mono text-xs">{r.number}</td><td className="px-3 py-1.5">{r.name}</td>
                {period && <><Num v={r.opening_debit} className="text-slate-500" /><Num v={r.opening_credit} className="text-slate-500" /><Num v={r.period_debit} /><Num v={r.period_credit} /></>}
                <Num v={r.debit} className="font-semibold" /><Num v={r.credit} className="font-semibold" />
              </tr>
            ))}
            {!data.rows.length && <tr><td colSpan={period ? 8 : 4} className="px-3 py-6 text-center text-slate-400 text-sm">Aucun solde pour cette période.</td></tr>}
            <tr className="bg-slate-50 font-bold">
              <td></td><td className="px-3 py-2 uppercase text-xs">Total</td>
              {period && <><Num v={t.opening_debit} blankZero={false} /><Num v={t.opening_credit} blankZero={false} /><Num v={t.period_debit} blankZero={false} /><Num v={t.period_credit} blankZero={false} /></>}
              <td className="px-3 py-2 text-right font-mono tabular-nums" data-testid="tb-total-debit">{money(data.total_debit)}</td>
              <td className="px-3 py-2 text-right font-mono tabular-nums" data-testid="tb-total-credit">{money(data.total_credit)}</td>
            </tr>
          </tbody>
        </Table>
      </div>
    </Card>
  );
}
